// ─── A company's name, as it should read (sprint 17) ─────────────────────────
// Finnhub hands names over as the exchange files them: "TAIWAN SEMICONDUCTOR
// MANUFACTURING CO LTD-SP ADR", "ACME INC- ADR". Two fixes, and only these:
//   · a hyphen with a space on one side only gets one on both: "INC- ADR"
//     → "INC - ADR"
//   · a hyphen glued to a share-class suffix is spaced: "LTD-SP ADR" →
//     "LTD - SP ADR", "HOLDING-CL A" → "HOLDING - CL A"
// A hyphen inside a name stays exactly as it is: "Coca-Cola",
// "NOVO-NORDISK", "Rolls-Royce". Nothing else is rewritten · no case changes,
// no dropped words.
// Capitals and whole words only: "ADR" is a suffix, the "Adr" in
// "Bio-Adrenal" is not (review).
const SUFFIX = String.raw`(?:SPON(?:SORED|S)?\s+ADR|SP\s+ADR|ADR|ADS|CL(?:ASS)?\s+[A-Z]|REG|PFD|UNITS?|WTS?)\b`;

export function companyName(name) {
  if (typeof name !== "string") return name;
  let s = name.replace(/\s+/g, " ").trim();
  // a space on one side only
  s = s.replace(/(\S)\s+-(?=\S)/g, "$1 - ").replace(/(\S)-\s+(?=\S)/g, "$1 - ");
  // glued to a share-class suffix
  s = s.replace(new RegExp(String.raw`(\S)-(?=${SUFFIX})`, "g"), "$1 - ");
  return s;
}
